module.exports = __webpack_public_path__ + "static/ko-e67dae2e6a79620ac76fc805d8be0483.png";